import { AccordionButton, AccordionPanel } from '@chakra-ui/react';
import styled from 'styled-components';

export const Button = styled(AccordionButton)<{ $isExpanded: boolean }>`
  border: 0 none;
  background-color: ${({ theme }) => theme.colors['neutral-0']};
  display: flex;
  padding: 0 !important;

  &:hover {
    background: ${({ theme }) => theme.colors['neutral-20']} !important;
    cursor: pointer;
  }

  &:not(:hover) .toggle-colapse {
    span {
      display: ${({ $isExpanded }) => ($isExpanded ? 'inline' : 'none')};
    }

    svg {
      color: ${({ $isExpanded, theme }) =>
        $isExpanded ? theme.colors['primary-60'] : theme.colors['neutral-90']};
    }
  }
`;

export const Wrapper = styled.div``;

export const TeamWrapper = styled.div`
  display: flex;
  width: 260px;
  padding: 8px 16px;
  gap: 12px;
  align-items: center;

  & > * {
    margin: 0;
  }
`;

export const TeamName = styled.p`
  color: ${({ theme }) => theme.colors['neutral-90']};
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  text-align: left;
`;

export const TeamMembersCounter = styled.p`
  color: ${({ theme }) => theme.colors['neutral-90']};
  font-size: 14px;
  line-height: 150%;
  text-align: left;
`;

export const TeamMembersWrapper = styled.div`
  display: flex;
  padding: 8px 16px;
  gap: 4px;
  align-items: center;
  flex-grow: 1;

  & > * {
    margin: 0;
  }
`;

export const OptionsWrapper = styled.div`
  padding: 8px 16px;
`;

export const ToggleColapse = styled.button`
  color: ${({ theme }) => theme.colors['primary-60']};
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  display: flex;
  gap: 8px;
  align-items: center;
  border: 0 none;
  background-color: transparent;
  cursor: pointer;

  & > svg {
    width: 12px;
    height: 12px;
  }
`;

export const ExpandedPanel = styled(AccordionPanel)`
  background: ${({ theme }) => theme.colors['neutral-20']};
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.07) inset;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  padding-inline-start: 64px !important;
  padding-inline-end: 16px !important;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PTOTypeTitleContainer = styled.div`
  margin-bottom: 4px;
  display: flex;
  gap: 8px;
  align-items: center;

  & > svg {
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    fill: ${({ theme }) => theme.colors['neutral-90']};
  }

  & > p {
    display: inline-block;
    color: ${({ theme }) => theme.colors['neutral-90']};
    font-size: 14px;
    font-weight: 600;
    line-height: 150%;
    flex-grow: 1;
  }
`;

export const PTOsTable = styled.div`
  padding: 12px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
`;

export const PTOTableLabel = styled.p`
  color: ${({ theme }) => theme.colors['neutral-90']};
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

export const PTOsTableTitle = styled(PTOTableLabel)`
  display: block;
  margin-bottom: 8px;
`;

export const PTOListItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 14px;

  &:not(:first-of-type) {
    padding-top: 4px;
  }

  &:not(:last-of-type) {
    padding-bottom: 4px;
    border-bottom: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  }

  & > div > * {
    margin-right: 0;
  }

  & > div {
    display: flex;
    align-items: center;

    &:last-child {
      justify-content: flex-end;
    }
  }
`;

export const PTOListUserName = styled.p`
  display: inline-block;
  padding-left: 8px;
  color: ${({ theme }) => theme.colors['primary-60']};
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
`;

export const RequestAnswerButton = styled.button`
  cursor: pointer;
  display: flex;
  gap: 4px;
  align-items: center;
  color: ${({ theme }) => theme.colors['primary-60']};
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  border: 0 none;
  background-color: transparent;

  & > svg {
    color: ${({ theme }) => theme.colors['primary-60']};
    width: 14px;
    height: 14px;
  }
`;
